import { QueryClient as e } from "./contact-channels110.js";
const t = new e();
export {
  t as queryClient
};
//# sourceMappingURL=contact-channels76.js.map
